module.exports = __webpack_public_path__ + "static/media/Payroll_icon-1.19a5fd63.png";